export var getListStatus = {
  data () {
    return {
      selectedList: null,

      selectedStatus: null,
      selectedType: null
    }
  },

  watch: {
    '$route.params': function () {
      // console.log($route.params.type)
      // this.selectedList = ''
      // this.$refs.toolbarNav.selected.name = this.$route.params.status ? this.$route.params.status : this.$route.params.type
    },

    selectedList () {
      let type = '', status = this.$route.params.status
      console.log(this.$route.params)

      if (this.$route.params.type && !status) {
        type = this.$route.params.type + '/'
      }

      // this.$refs.toolbarNav.selected.name = 'ALl'

      this.$router.push(type + this.selectedList)
    }
  }
}
